import React from 'react';

const ModalSuccess = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    style={{
      width: 52,
      height: 52,
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="52" height="52" fill="#108EE9" rx="26" />
      <rect
        width="28"
        height="28"
        x="12"
        y="12"
        fill="#108EE9"
        stroke="#FFF"
        strokeWidth="2"
        rx="14"
      />
      <path
        fill="#FFF"
        d="M20.75 26.25a1.06 1.06 0 0 0 0 1.5L24 31l8.229-7.772a1.03 1.03 0 0 0 .021-1.478 1.098 1.098 0 0 0-1.525-.026L24 28l-1.75-1.75a1.06 1.06 0 0 0-1.5 0z"
      />
    </g>
  </svg>
);

export default ModalSuccess;
